import { motion } from 'framer-motion'
import { ArrowRight, Phone, Mail } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../context/LanguageContext'

const CTA = () => {
  const { t } = useLanguage()

  return (
    <section className="py-24 bg-gradient-to-br from-dark via-bronze-950 to-dark relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <motion.div 
          className="absolute top-0 left-0 w-96 h-96 bg-gradient-gold rounded-full blur-3xl opacity-10"
          animate={{
            x: [0, 100, 0],
            y: [0, 50, 0],
            scale: [1, 1.2, 1]
          }}
          transition={{ duration: 20, repeat: Infinity }}
        />
        <motion.div 
          className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-bronze rounded-full blur-3xl opacity-10"
          animate={{
            x: [0, -100, 0],
            y: [0, -50, 0],
            scale: [1, 1.3, 1]
          }}
          transition={{ duration: 25, repeat: Infinity, delay: 5 }}
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center"
        >
          {/* Icon */}
          <motion.div
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            animate={{
              y: [0, -10, 0],
              rotate: [0, 5, -5, 0]
            }}
            transition={{
              delay: 0.2,
              type: 'spring',
              y: { duration: 3, repeat: Infinity },
              rotate: { duration: 4, repeat: Infinity }
            }}
            className="inline-block mb-8"
          >
            <div className="w-20 h-20 rounded-full bg-gradient-gold flex items-center justify-center shadow-gold-lg relative">
              <Mail className="w-10 h-10 text-white" />
              <motion.div
                animate={{ scale: [1, 1.3, 1], opacity: [0.5, 0, 0.5] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="absolute inset-0 rounded-full bg-gradient-gold"
              />
            </div>
          </motion.div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-cream mb-6">
            {t('cta.title')} <span className="text-gradient-gold">{t('cta.titleHighlight')}</span>
          </h2>

          {/* Description */}
          <p className="text-xl text-beige-200 mb-10 max-w-2xl mx-auto">
            {t('cta.description')}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
            <Link 
              to="/contact"
              className="btn-primary flex items-center space-x-2 group"
            >
              <span>{t('cta.button')}</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            
            <a
              href="tel:+355695658665"
              className="btn-secondary flex items-center space-x-2"
            >
              <Phone className="w-5 h-5" />
              <span>+355 69 565 8665</span>
            </a>
          </div>

          {/* Or Text */}
          <p className="text-beige-300">
            {t('cta.phone')}
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default CTA
